module.exports = __webpack_public_path__ + "img/shinsei_logo2.815192db.gif";